const doctorInformationProfile = {
  givenNames: 'Doctor interno',
  surnames: 'Testing',
  dateOfBirth: '1998-03-30',
  rfc: '457224455',
  curp: '6546546546',
  email: 'correodeprueba@osigu.com',
  medicalCircle: 'Medicina general',
  subnet: 'Red platino',
  responsibilityPolicies: 'Poliza de responsabilidad',
  rcPolicy: '2020-03-30',
  cost: '2500',
  street: 'Calle 5',
  cologne: 'Colonia mariscal',
  city: 'Ciudad de mexico',
  state: 'Estado de mexico',
  postalCode: '010055',
  country: 'Mexico',
  rating: 4,
  taxResidence: {
    street: 'Calle 55',
    cologne: 'Colonia mariscoles',
    city: 'Ciudad de mexico',
    state: 'Estado de mexico',
    postalCode: '010056',
    country: 'Mexico',
  },
  offices: [
    {
      id: 'office1',
      street: 'Calle 55',
      cologne: 'Colonia mariscoles',
      city: 'Ciudad de mexico',
      state: 'Estado de mexico',
      postalCode: '010056',
      country: 'Mexico',
      fax: '6465465',
      phoneOffice: '654654654',
      startTime: '08:30',
      endTime: '16:30',
      hospital: {
        street: 'Calle 55',
        cologne: 'Colonia mariscoles',
        city: 'Ciudad de mexico',
        state: 'Estado de mexico',
        postalCode: '010056',
        country: 'Mexico',
        fax: '6465465',
        phoneOffice: '654654654'
      }
    },
    {
      id: 'office2',
      street: 'Calle 45',
      cologne: 'Colonia mari',
      city: 'Ciudad de mexico',
      state: 'Jalisco',
      postalCode: '013056',
      country: 'Mexico',
      fax: '6465465',
      phoneOffice: '654654444',
      startTime: '08:30',
      endTime: '16:30',
      hospital: {
        street: 'Calle 45',
        cologne: 'Colonia mari',
        city: 'Ciudad de mexico',
        state: 'Jalisco',
        postalCode: '013056',
        country: 'Mexico',
        fax: '6465465',
        phoneOffice: '654654654'
      }
    }
  ],
  banks: [
    {
      id: 'bank1',
      bank: 'Bancuver',
      clabe: '46546546'
    },
    {
      id: 'bank2',
      bank: 'Banamex',
      clabe: '46544555'
    }
  ],
  titles: [
    {
      name: 'Medico forense',
      professionalLicense: '654654654'
    },
    {
      name: 'Medico cirujano',
      professionalLicense: '4445555'
    }
  ],
  specialties: [
    {
      name: 'Cirugia',
      specialtyId: '646546546'
    },
    {
      name: 'Quirurgico',
      specialtyId: '566546546546'
    }
  ],
  assistants: [
    {
      givenNames: 'Asistente',
      surnames: 'De pruebas',
      dateOfBirth: '2004-03-17',
      rfc: '887999',
      email: 'asistente1@email.com'
    },
    {
      givenNames: 'Asistente 2',
      surnames: 'De pruebas 2',
      dateOfBirth: '2004-01-17',
      rfc: '887777',
      email: 'asistente2@email.com'
    }
  ]
}

/* const providerProfile = {
  status: 'APPROVED',
  fullName: 'Doctor interno apellidos',
  givenNames: 'Doctor interno',
  surnames: 'apellidos',
  taxIdentificationNumber: 'rfc number',
  emailAddress: 'correodeprueba@osigu.com',
  additionalProperties: [
    {
      id: '1',
      key: 'date-of-birth',
      type: 'DATE',
      value: '1998-03-30'
    },
    {
      id: '99',
      key: 'cost',
      type: 'NUMBER',
      value: '254122'
    },
    {
      id: '2',
      key: 'curp',
      type: 'STRING',
      value: '66546564465465'
    },
    {
      id: '3',
      key: 'medical-circle',
      type: 'STRING',
      value: 'Medicina general'
    },
    {
      id: '4',
      key: 'subnet',
      type: 'STRING',
      value: 'Red platino'
    },
    {
      id: '5',
      key: 'responsibility-policies',
      type: 'STRING',
      value: 'Poliza de responsabilidad'
    },
    {
      id: '6',
      key: 'rc-policy',
      type: 'DATE',
      value: '2020-03-30'
    },
    {
      id: '7',
      key: 'street',
      type: 'STRING',
      value: 'Calle 5'
    },
    {
      id: '8',
      key: 'cologne',
      type: 'STRING',
      value: 'Colonia mariscal'
    },
    {
      id: '9',
      key: 'city',
      type: 'STRING',
      value: 'Ciudad de mexico'
    },
    {
      id: '10',
      key: 'state',
      type: 'STRING',
      value: 'Estado de mexico'
    },
    {
      id: '11',
      key: 'postal-code',
      type: 'STRING',
      value: '010055'
    },
    {
      id: '12',
      key: 'country',
      type: 'STRING',
      value: 'Mexico'
    },
    {
      id: '13',
      key: 'rating',
      type: 'NUMBER',
      value: 4
    },
    {
      id: '15',
      key: 'tax-residence-street',
      type: 'STRING',
      value: 'Calle 55'
    },
    {
      id: '16',
      key: 'tax-residence-cologne',
      type: 'STRING',
      value: 'Colonia mariscal'
    },
    {
      id: '17',
      key: 'tax-residence-city',
      type: 'STRING',
      value: 'Ciudad de mexico'
    },
    {
      id: '18',
      key: 'tax-residence-state',
      type: 'STRING',
      value: 'Estado de mexico'
    },
    {
      id: '19',
      key: 'tax-residence-postal-code',
      type: 'STRING',
      value: '010055'
    },
    {
      id: '20',
      key: 'tax-residence-country',
      type: 'STRING',
      value: 'Mexico'
    },


    {
      id: '21',
      key: 'first-office-street',
      type: 'STRING',
      value: 'Calle 55'
    },
    {
      id: '22',
      key: 'first-office-cologne',
      type: 'STRING',
      value: 'Colonia mariscoles'
    },
    {
      id: '23',
      key: 'first-office-city',
      type: 'STRING',
      value: 'Ciudad de mexico'
    },
    {
      id: '24',
      key: 'first-office-state',
      type: 'STRING',
      value: 'Estado de mexico'
    },
    {
      id: '25',
      key: 'first-office-postal-code',
      type: 'STRING',
      value: '010056'
    },
    {
      id: '26',
      key: 'first-office-country',
      type: 'STRING',
      value: 'Mexico'
    },
    {
      id: '27',
      key: 'first-office-fax',
      type: 'STRING',
      value: '6465465'
    },
    {
      id: '28',
      key: 'first-office-phone-office',
      type: 'STRING',
      value: '654654654'
    },
    {
      id: '29',
      key: 'first-office-start-time',
      type: 'STRING',
      value: '08:30'
    },
    {
      id: '30',
      key: 'first-office-end-time',
      type: 'STRING',
      value: '16:30'
    },
    {
      id: '31',
      key: 'first-office-hospital-street',
      type: 'STRING',
      value: 'Calle 55'
    },
    {
      id: '32',
      key: 'first-office-hospital-cologne',
      type: 'STRING',
      value: 'Colonia mariscoles'
    },
    {
      id: '33',
      key: 'first-office-hospital-city',
      type: 'STRING',
      value: 'Ciudad de mexico'
    },
    {
      id: '34',
      key: 'first-office-hospital-state',
      type: 'STRING',
      value: 'Estado de mexico'
    },
    {
      id: '35',
      key: 'first-office-hospital-postal-code',
      type: 'STRING',
      value: '010056'
    },
    {
      id: '36',
      key: 'first-office-hospital-country',
      type: 'STRING',
      value: 'Mexico'
    },
    {
      id: '37',
      key: 'first-office-hospital-fax',
      type: 'STRING',
      value: '6465465'
    },
    {
      id: '38',
      key: 'first-office-hospital-phone-office',
      type: 'STRING',
      value: '654654654'
    },


    {
      id: '39',
      key: 'second-office-street',
      type: 'STRING',
      value: 'Calle 45'
    },
    {
      id: '40',
      key: 'second-office-cologne',
      type: 'STRING',
      value: 'Colonia mari'
    },
    {
      id: '41',
      key: 'second-office-city',
      type: 'STRING',
      value: 'Ciudad de mexico'
    },
    {
      id: '42',
      key: 'second-office-state',
      type: 'STRING',
      value: 'Jalisco'
    },
    {
      id: '43',
      key: 'second-office-postal-code',
      type: 'STRING',
      value: '013056'
    },
    {
      id: '44',
      key: 'second-office-country',
      type: 'STRING',
      value: 'Mexico'
    },
    {
      id: '45',
      key: 'second-office-fax',
      type: 'STRING',
      value: '6465465'
    },
    {
      id: '46',
      key: 'second-office-phone-office',
      type: 'STRING',
      value: '654654444'
    },
    {
      id: '47',
      key: 'second-office-startTime',
      type: 'STRING',
      value: '08:30'
    },
    {
      id: '48',
      key: 'second-office-endTime',
      type: 'STRING',
      value: '16:30'
    },
    {
      id: '49',
      key: 'second-office-hospital-street',
      type: 'STRING',
      value: 'Calle 45'
    },
    {
      id: '50',
      key: 'second-office-hospital-cologne',
      type: 'STRING',
      value: 'Colonia mari'
    },
    {
      id: '51',
      key: 'second-office-hospital-city',
      type: 'STRING',
      value: 'Ciudad de mexico'
    },
    {
      id: '52',
      key: 'second-office-hospital-state',
      type: 'STRING',
      value: 'Jalisco'
    },
    {
      id: '53',
      key: 'second-office-hospital-postal-code',
      type: 'STRING',
      value: '013056'
    },
    {
      id: '54',
      key: 'second-office-hospital-country',
      type: 'STRING',
      value: 'Mexico'
    },
    {
      id: '55',
      key: 'second-office-hospital-fax',
      type: 'STRING',
      value: '6465465'
    },
    {
      id: '56',
      key: 'second-office-hospital-phone-office',
      type: 'STRING',
      value: '654654654'
    },


    {
      id: '57',
      key: 'first-bank-name',
      type: 'STRING',
      value: 'Bancuver'
    },
    {
      id: '58',
      key: 'first-bank-clabe',
      type: 'STRING',
      value: '46546546'
    },
    {
      id: '59',
      key: 'second-bank-name',
      type: 'STRING',
      value: 'Banamex'
    },
    {
      id: '60',
      key: 'second-bank-clabe',
      type: 'STRING',
      value: '46544555'
    },


    {
      id: '61',
      key: 'first-title-name',
      type: 'STRING',
      value: 'Medico forense'
    },
    {
      id: '62',
      key: 'first-title-professional-license',
      type: 'STRING',
      value: '654654654'
    },
    {
      id: '63',
      key: 'second-title-name',
      type: 'STRING',
      value: 'Medico cirujano'
    },
    {
      id: '64',
      key: 'second-title-professional-license',
      type: 'STRING',
      value: '4445555'
    },


    {
      id: '65',
      key: 'first-specialty-name',
      type: 'STRING',
      value: 'Cirugia'
    },
    {
      id: '66',
      key: 'first-specialty-number',
      type: 'STRING',
      value: '646546546'
    },
    {
      id: '67',
      key: 'second-specialty-name',
      type: 'STRING',
      value: 'Quirurgico'
    },
    {
      id: '68',
      key: 'second-specialty-number',
      type: 'STRING',
      value: '566546546546'
    },


    {
      id: '69',
      key: 'first-assistant-given-names',
      type: 'STRING',
      value: 'Asistente'
    },
    {
      id: '70',
      key: 'first-assistant-surnames',
      type: 'STRING',
      value: 'De pruebas'
    },
    {
      id: '71',
      key: 'first-assistant-date-of-birth',
      type: 'DATE',
      value: '2004-03-17'
    },
    {
      id: '72',
      key: 'first-assistant-rfc',
      type: 'STRING',
      value: '887999'
    },
    {
      id: '73',
      key: 'first-assistant-email',
      type: 'STRING',
      value: 'asistente1@email.com'
    },
    {
      id: '74',
      key: 'second-assistant-given-names',
      type: 'STRING',
      value: 'Asistente 2'
    },
    {
      id: '75',
      key: 'second-assistant-surnames',
      type: 'STRING',
      value: 'De pruebas 2'
    },
    {
      id: '76',
      key: 'second-assistant-date-of-birth',
      type: 'DATE',
      value: '2004-03-17'
    },
    {
      id: '77',
      key: 'second-assistant-rfc',
      type: 'STRING',
      value: '887777'
    },
    {
      id: '78',
      key: 'second-assistant-email',
      type: 'STRING',
      value: 'asistente2@email.com'
    },
  ]
} */
const providerProfile = {
  "provider_registration_request_id": "d5ccc513-9007-4de7-8984-f051bab58bfc",
  "status": "DATA_REQUIRED",
  "name": "Ana Paula Camara Weber",
  "given_names": null,
  "surnames": null,
  "provider_type": "DOCTOR",
  "entity_type": "NATURAL",
  "country_code": "MX",
  "legal_name": "Ana Paula Camara Weber",
  "tax_identification_number": "CAWA930417CY5",
  "physical_address": "Calle Martínez 4-71, Cerrada de La Misión",
  "email_address": "estuardo@osigu.com",
  "phone_area_code": "+52",
  "phone_number": "9348-92291",
  "bank_slug": "mx-azteca",
  "bank_account_type": "CHECKING_ACCOUNT",
  "bank_account_number": null,
  "locale": "es-MX",
  "time_zone": "America/Mexico_City",
  "medical_license_verification_institution_slug": null,
  "additional_specialties": [
    {
      "id": "2fa08097-55ea-4b45-b132-c3af1de64c42",
      "specialty_order": 0,
      "medical_license_number": "200030102",
      "medical_issuing_institution": "Universidad Nacional Autónoma de México",
      "specialty_slug": null,
      "specialty_name": "Alergología",
      "specialty_valid_from": 2018,
      "enabled": true,
      "created_at": "2022-06-03T06:04:20.223Z",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "updated_at": null,
      "updated_by": null
    }
  ],
  "additional_properties": [
    {
      "id": "c1327ec4-3b5e-4f0d-a2aa-27a56f31afc7",
      "key": "first_name",
      "fallback_label": "Primer nombre",
      "type": "STRING",
      "value": "Ana",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.219Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "884a2191-d6f9-4e8f-b2f1-c408cccd4510",
      "key": "second_name",
      "fallback_label": "Segundo nombre",
      "type": "STRING",
      "value": "Ana",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.219Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "ecebfedf-c0e2-4a75-8924-1fe48846f954",
      "key": "first_surname",
      "fallback_label": "Primer apellido",
      "type": "STRING",
      "value": "Ana",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.219Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "f5a008ce-9e5f-4c6f-ae87-a3a8d257cf93",
      "key": "second_surname",
      "fallback_label": "Segundo apellido",
      "type": "STRING",
      "value": "Ana",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.219Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "549d1e9a-9243-4654-b161-dbeb4aa6b3e5",
      "key": "date_of_birth",
      "fallback_label": "Fecha de nacimiento",
      "type": "DATE",
      "value": "1993-04-17",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.219Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "9fe24f9c-72e0-4424-9e2d-9f3032acc505",
      "key": "curp",
      "fallback_label": "CURP",
      "type": "STRING",
      "value": "CAWA930417MDFMBN04",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.219Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "0617ecde-9bf1-481d-8d54-3c623cfa7d24",
      "key": "identity_document_type",
      "fallback_label": "Tipo documento identificación",
      "type": "STRING",
      "value": "INE",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.219Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "d4c2981e-2675-4676-81ee-60850470cac4",
      "key": "identity_document_number",
      "fallback_label": "Número de documento de identificación",
      "type": "STRING",
      "value": "299229",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.219Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "bcaf4ad1-1dbd-4462-a714-e0e96985d3f1",
      "key": "professional_responsibility_policy",
      "fallback_label": "Póliza de responsabilidad profesional",
      "type": "STRING",
      "value": "29299229000",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.219Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "7fb52cce-3465-402c-9a28-666fc87d42b3",
      "key": "professional_responsibility_policy_expiration_date",
      "fallback_label": "Fecha de vigencia de póliza de responsabilidad profesional",
      "type": "DATE",
      "value": "2026-12-31",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.219Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "a925c467-9f96-4d16-8d84-97d3727fe3e7",
      "key": "residence_state",
      "fallback_label": "Estado de residencia",
      "type": "STRING",
      "value": "Aguascalientes",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.219Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "36381db4-a7e6-4317-a61d-7eff8cc85959",
      "key": "residence_city",
      "fallback_label": "Ciudad de residencia",
      "type": "STRING",
      "value": "Aguascalientes",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.219Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "3d12f8b3-9a71-437d-9aa7-d21a466dce36",
      "key": "residence_address",
      "fallback_label": "Dirección de residencia",
      "type": "STRING",
      "value": "Dirección de residencia",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.219Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "61f50cef-0955-4744-ab6d-a4656736926e",
      "key": "residence_street",
      "fallback_label": "Calle de residencia",
      "type": "STRING",
      "value": "C1",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.219Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "267e355d-0ac3-436b-91d0-ef9dfc8bf56a",
      "key": "residence_colony",
      "fallback_label": "Colonia de residencia",
      "type": "STRING",
      "value": "Balcones del Valle",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.219Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "40116413-40b0-423f-97d3-52966bef684a",
      "key": "residence_postal_code",
      "fallback_label": "Código postal de residencia",
      "type": "STRING",
      "value": "10123",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.22Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "6331295c-5b2d-475b-a4c9-855caa54bd34",
      "key": "fiscal_address_state",
      "fallback_label": "Estado de domicilio fiscal",
      "type": "STRING",
      "value": "Aguascalientes",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.22Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "65236241-37e4-4c06-ba8e-e3267bb368f0",
      "key": "fiscal_address_city",
      "fallback_label": "Ciudad de domicilio fiscal",
      "type": "STRING",
      "value": "Asientos",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.22Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "3ac01057-5554-4c40-a55f-ab6265ed8e82",
      "key": "fiscal_address_address",
      "fallback_label": "Dirección de domicilio fiscal",
      "type": "STRING",
      "value": "Dirección fiscal",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.22Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "50a4f706-4af1-4949-923a-187521daad81",
      "key": "fiscal_address_street",
      "fallback_label": "Calle de domicilio fiscal",
      "type": "STRING",
      "value": "C2",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.221Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "876c994a-a0d1-4470-b5c4-76b7de70178b",
      "key": "fiscal_address_colony",
      "fallback_label": "Colonia de domicilio fiscal",
      "type": "STRING",
      "value": "Casa Blanca",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.221Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "13ae1ab5-df3c-4adf-a3b2-6da7f69bddd8",
      "key": "fiscal_address_postal_code",
      "fallback_label": "Código postal de domicilio fiscal",
      "type": "STRING",
      "value": "10456",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.221Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "aaf3e6b6-fa08-4315-b9fe-e78ddb56f482",
      "key": "first_doctor_office_state",
      "fallback_label": "Estado de Consultorio #1",
      "type": "STRING",
      "value": "Aguascalientes",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.221Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "1088ac60-bb78-4d17-9362-34162471b3ea",
      "key": "first_doctor_office_city",
      "fallback_label": "Ciudad de Consultorio #1",
      "type": "STRING",
      "value": "Calvillo",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.222Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "fc831763-80ff-4b96-bf3c-39f6e6683642",
      "key": "first_doctor_office_address",
      "fallback_label": "Dirección de Consultorio #1",
      "type": "STRING",
      "value": "Calle Martínez 4-71, Cerrada de La Misión",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.222Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "0f59bc14-d781-4570-b0b8-f529d384e033",
      "key": "first_doctor_office_street",
      "fallback_label": "Calle de Consultorio #1",
      "type": "STRING",
      "value": "Calle Martínez",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.222Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "525bdc0d-b6f7-4aec-911d-127ab37b019f",
      "key": "first_doctor_office_colony",
      "fallback_label": "Colonia de Consultorio #1",
      "type": "STRING",
      "value": "Cerrada de La Misión",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.222Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "3cd9741b-2064-4e1c-bd8f-cfe38c60be4d",
      "key": "first_doctor_office_postal_code",
      "fallback_label": "Código postal de Consultorio #1",
      "type": "STRING",
      "value": "10987",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.222Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "e27bbda8-3545-43d0-bbc0-1ed686169fe5",
      "key": "first_doctor_office_phone",
      "fallback_label": "Número de teléfono de Consultorio #1",
      "type": "STRING",
      "value": "9348-92291",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.222Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "a8e147b6-0503-42f6-ae72-b58681d07a86",
      "key": "first_assistant_first_name",
      "fallback_label": "Primer nombre - asistente #1",
      "type": "STRING",
      "value": "Juan",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.222Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "23caab7e-662c-47b2-b575-05bc9696b268",
      "key": "first_assistant_middle_name",
      "fallback_label": "Segundo nombre - asistente #1",
      "type": "STRING",
      "value": "Francisco",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.222Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "5f67b00a-ca7b-4963-add4-d5a43895a79a",
      "key": "first_assistant_first_surname",
      "fallback_label": "Primer apellido - asistente #1",
      "type": "STRING",
      "value": "Bajo",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.222Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "055dbfa0-7d49-4e43-a531-5f877f0aded4",
      "key": "first_assistant_second_surname",
      "fallback_label": "Segundo apellido - asistente #1",
      "type": "STRING",
      "value": "",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.222Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "dd9e18e0-cd2e-499a-ae61-5a86c074fb75",
      "key": "first_assistant_date_of_birth",
      "fallback_label": "Fecha de nacimiento - asistente #1",
      "type": "DATE",
      "value": "1999-01-23",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.222Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "95d2a248-b2f4-46e4-8885-42f05f57539a",
      "key": "first_assistant_rfc",
      "fallback_label": "RFC - asistente #1",
      "type": "STRING",
      "value": "ISU0608014G4",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.222Z",
      "updated_by": null,
      "updated_at": null
    },
    {
      "id": "71aa7324-e354-46e3-a2fb-ecb62f3e88f9",
      "key": "first_assistant_email_address",
      "fallback_label": "Correo electrónico - asistente #1",
      "type": "STRING",
      "value": "jegatest@osigu.com",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "created_at": "2022-06-03T06:04:20.222Z",
      "updated_by": null,
      "updated_at": null
    }
  ],
  "additional_information_required": [
    {
      "id": "46912668-0dad-4d0c-a609-4594bcdd9826",
      "required_data_name": "Estado de Cuenta Bancaria",
      "description": "El documento del estado de cuenta no es válido, por favor suba de nuevo el documento",
      "file_required": true,
      "answer_value": null,
      "answer_original_file_name": null,
      "answer_file_path": null,
      "status": "PENDING",
      "internal_notes": null,
      "enabled": true,
      "created_at": "2022-06-03T10:44:38.072Z",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "updated_at": null,
      "updated_by": null
    },
    {
      "id": "e1a543d5-ce28-4fc9-a301-36301f6d4b3e",
      "required_data_name": "Evidencia Cédula profesional Título #1",
      "description": "La imágen del carné de la cédula profesional del Título #1 esta muy borrosa, por favor suba de nuevo el archivo",
      "file_required": true,
      "answer_value": "Perdón ya lo subí de nuevo con mejor calidad",
      "answer_original_file_name": "doctora_profile.png",
      "answer_file_path": "/demo/registration-request-documents/required-data-e1a543d5-ce28-4fc9-a301-36301f6d4b3e.png",
      "status": "REJECTED",
      "internal_notes": "Subió la foto de su perfil en vez de su carné profesional",
      "enabled": true,
      "created_at": "2022-06-03T10:44:38.071Z",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "updated_at": "2022-06-03T10:47:17.661Z",
      "updated_by": "mx-gnp-seguros-registration-request-web"
    },
    {
      "id": "a91c50e8-9f9b-4b01-917f-2bfb10b4a4c8",
      "required_data_name": "Cédula profesional Título #1",
      "description": "La cédula profesional no coincide con el registro nacional de profesionales, por favor rectifique valor.",
      "file_required": false,
      "answer_value": "Se lo juro, ese es el número de cédula profesional",
      "answer_original_file_name": null,
      "answer_file_path": null,
      "status": "ANSWERED",
      "internal_notes": "Esta es la primera solicitud.",
      "enabled": true,
      "created_at": "2022-06-03T10:44:38.071Z",
      "created_by": "mx-gnp-seguros-registration-request-web",
      "updated_at": "2022-06-03T10:45:52.89Z",
      "updated_by": "mx-gnp-seguros-registration-request-web"
    }
  ],
  "standardized_bank_account_number": "127475000255648974",
  "sponsors": null,
  "medical_license_number": "200030102",
  "main_specialty_name": "Alergología",
  "electronic_invoice_enabled": false,
  "organization_slug": null,
  "ekyc_uri": null
}

const officeFieldMapping = [
  {
    key: 'doctor_office_street',
    field: 'street',
  },
  {
    key: 'doctor_office_colony',
    field: 'cologne'
  },
  {
    key: 'doctor_office_city',
    field: 'city'
  },
  {
    key: 'doctor_office_state',
    field: 'state'
  },
  {
    key: 'doctor_office_postal_code',
    field: 'postalCode'
  },
  {
    key: 'doctor_office_country',
    field: 'country'
  },
  {
    key: 'doctor_office_fax',
    field: 'fax'
  },
  {
    key: 'doctor_office_phone',
    field: 'phoneOffice'
  },
  {
    key: 'doctor_office_start_time',
    field: 'startTime'
  },
  {
    key: 'doctor_office_end_time',
    field: 'endTime'
  },
  {
    key: 'doctor_office_hospital_street',
    field: 'street',
    hospital: true
  },
   {
    key: 'doctor_office_hospital_colony',
    field: 'cologne',
    hospital: true
  },
    {
    key: 'doctor_office_hospital_city',
    field: 'city',
    hospital: true
  },
  {
    key: 'doctor_office_hospital_state',
    field: 'state',
    hospital: true
  },
  {
    key: 'doctor_office_hospital_postal_code',
    field: 'postalCode',
    hospital: true
  },
  {
    key: 'doctor_office_hospital_country',
    field: 'country',
    hospital: true
  },
  {
    key: 'doctor_office_hospital_fax',
    field: 'fax',
    hospital: true
  },
  {
    key: 'doctor_office_hospital_phone_office',
    field: 'phoneOffice',
    hospital: true
  }
]

const bankFieldMapping = [
  {
    key: 'bank_name',
    field: 'bank'
  },
  {
    key: 'bank_clabe',
    field: 'clabe'
  }
]

const titleFieldMapping = [
  {
    key: 'title_name',
    field: 'name'
  },
  {
    key: 'title_professional_license',
    field: 'professionalLicense'
  }
]

const specialtyFieldMapping = [
  {
    key: 'specialty_name',
    field: 'name'
  },
  {
    key: 'specialty_number',
    field: 'specialtyId'
  }
]

const getProviderProfile = (providerData) => {
  const providerInformation = {}
  
  providerInformation['status'] = providerData.status
  providerInformation['name'] = providerData.name || providerData.fullName
  providerInformation['givenNames'] = providerData.givenNames
  providerInformation['surnames'] = providerData.surnames
  providerInformation['rfc'] = providerData.taxIdentificationNumber
  providerInformation['email'] = providerData.emailAddress
  providerInformation['mainSpecialtyName'] = providerData.mainSpecialtyName
  providerInformation['medicalLicenseNumber'] = providerData.medicalLicenseNumber
  providerInformation['additionalInformationRequired'] = providerData.additionalInformationRequired

  providerInformation['dateOfBirth'] = getFieldValue('date_of_birth', providerData)
  providerInformation['curp'] = getFieldValue('curp', providerData)
  providerInformation['cost'] = getFieldValue('cost', providerData)
  providerInformation['medicalCircle'] = getFieldValue('medical_circle', providerData)
  providerInformation['subnet'] = getFieldValue('subnet', providerData)
  providerInformation['responsibilityPolicies'] = getFieldValue('professional_responsibility_policy', providerData)
  providerInformation['rcPolicy'] = getFieldValue('professional_responsibility_policy_expiration_date', providerData)

  providerInformation['street'] = getFieldValue('residence_street', providerData)
  providerInformation['cologne'] = getFieldValue('residence_colony', providerData)
  providerInformation['city'] = getFieldValue('residence_city', providerData)
  providerInformation['state'] = getFieldValue('residence_state', providerData)
  providerInformation['postalCode'] = getFieldValue('residence_postal_code', providerData)
  providerInformation['country'] = getFieldValue('residence_country', providerData)
  providerInformation['rating'] = getFieldValue('rating', providerData)

  if (existInformation('fiscal_address', providerData)) {
    providerInformation['taxResidence'] = {}
    providerInformation['taxResidence']['street'] = getFieldValue('fiscal_address_street', providerData)
    providerInformation['taxResidence']['cologne'] = getFieldValue('fiscal_address_colony', providerData)
    providerInformation['taxResidence']['city'] = getFieldValue('fiscal_address_city', providerData)
    providerInformation['taxResidence']['state'] = getFieldValue('fiscal_address_state', providerData)
    providerInformation['taxResidence']['postalCode'] = getFieldValue('fiscal_address_postal_code', providerData)
    providerInformation['taxResidence']['country'] = getFieldValue('fiscal_address_country', providerData)
  }

  if (providerData.additionalSpecialties && providerData.additionalSpecialties.length > 0) {
    const specialties = providerData.additionalSpecialties.map(specialty => ({
      name: specialty.specialtyName,
      specialtyId: specialty.medicalLicenseNumber
    }))
    providerInformation['specialties'] = specialties
      
  }
  
  if (existInformation('doctor_office', providerData)) {
    let numberPrefix = ''
    providerInformation['offices'] = []
    let office = {}
    const officeFields = getAnyFieldsInclude('doctor_office', providerData)

    for (let index = 0; index <= officeFields.length; index++) {
      const field = officeFields[index]
      const keyArray = field && field.key.split('_') || []
      if (numberPrefix !== keyArray[0] || index === officeFields.length) {
        numberPrefix = keyArray[0]
        if (Object.keys(office).length > 0) { 
          providerInformation['offices'].push(office)
        }        
        office = {}
      } 
      keyArray.shift()
      const key = keyArray.join('_')
      const fieldMapping = officeFieldMapping.find(mapping => mapping.key === key)
      if (fieldMapping) {
        if (fieldMapping.hospital) {
          if (typeof office['hospital'] === 'undefined') {
            office['hospital'] = {}
          }
          office['hospital'][fieldMapping.field] = field
        } else {
          office[fieldMapping.field] = field
        }
      }
    }
  }

  if (existInformation('bank', providerData)) {
    fillArrayValues('banks', 'bank', providerData, providerInformation, bankFieldMapping);
  }

  if (existInformation('title', providerData)) {
    fillArrayValues('titles', 'title', providerData, providerInformation, titleFieldMapping)
  }

  if (existInformation('specialty', providerData)) {
    fillArrayValues('specialties', 'specialty', providerData, providerInformation, specialtyFieldMapping)
  }

  return providerInformation

}

const fillArrayValues = (arrayName, fieldToSeach, providerData, providerDataDTO, mapping) => { 
  let numberPrefix = ''
    providerDataDTO[arrayName] = []
    let bank = {}
    const bankFields = getAnyFieldsInclude(fieldToSeach, providerData)

    for (let index = 0; index <= bankFields.length; index++) {
      const field = bankFields[index]
      const keyArray = field && field.key.split('_') || []
      if (numberPrefix !== keyArray[0] || index === bankFields.length) {
        numberPrefix = keyArray[0]
        if (Object.keys(bank).length > 0) { 
          providerDataDTO[arrayName].push(bank)
        }        
        bank = {}
      } 
      keyArray.shift()
      const key = keyArray.join('_')
      const fieldMapping = mapping.find(mapping => mapping.key === key)
      if (fieldMapping) {
        bank[fieldMapping.field] = field
      }
    }
}

const getFieldValue = (fieldToSearch, providerData) => {
  const field = providerData.additionalProperties.find(property => property.key === fieldToSearch)
  if (field) {
    return field
  }
  return null
}

const getAnyFieldsInclude = (fieldsToSearch, providerData) => {
  const fields = providerData.additionalProperties.filter(property => property.key.includes(fieldsToSearch))
  return fields || []
}

const existInformation = (key, providerData) => {
  const fields = providerData.additionalProperties.filter(property => property.key.includes(key))
  return fields && fields.length > 0
}

export {
  doctorInformationProfile,
  providerProfile,
  getProviderProfile
}